import { render, staticRenderFns } from "./TitleCreditName.vue?vue&type=template&id=42d48d79&scoped=true"
import script from "./TitleCreditName.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleCreditName.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleCreditName.vue?vue&type=style&index=0&id=42d48d79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d48d79",
  null
  
)

export default component.exports